import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { BasicList, Certification, Classification, NavigationRoute, State } from '@app/models';
import { AuthService } from '@auth0/auth0-angular';
import { Observable, ReplaySubject, map } from 'rxjs';

import { environment } from '@env/environment';
import { LoginService } from './login.service';

@Injectable({
  providedIn: 'root',
})
export class CommonService {
  constructor(
    private http: HttpClient,
    private auth: AuthService,
    private loginService: LoginService
  ) {}

  private states$: ReplaySubject<State[]> = new ReplaySubject<State[]>(1);
  private statesRetrieved = false;
  getStates(): Observable<State[]> {
    if (!this.statesRetrieved) {
      this.statesRetrieved = true;
      this.http.get<State[]>(`${environment.apiUrl}/api/general/Lookup/ListStates/State`).subscribe(this.states$);
    }

    return this.states$.asObservable();
  }

  private businessTypes$: ReplaySubject<BasicList[]> = new ReplaySubject<BasicList[]>(1);
  private businessTypesRetrieved = false;
  getBusinessTypes(): Observable<BasicList[]> {
    if (!this.businessTypesRetrieved) {
      this.businessTypesRetrieved = true;
      this.http
        .get<BasicList[]>(`${environment.apiUrl}/api/general/Lookup/ListBusinessTypes/BusinessTypes`)
        .subscribe(this.businessTypes$);
    }
    return this.businessTypes$.asObservable();
  }

  private projectTypes$: ReplaySubject<BasicList[]> = new ReplaySubject<BasicList[]>(1);
  private projectTypesRetrieved = false;
  getProjectTypes(): Observable<BasicList[]> {
    if (!this.projectTypesRetrieved) {
      this.projectTypesRetrieved = true;
      this.http
        .get<BasicList[]>(`${environment.apiUrl}/api/general/Lookup/ListProjectTypes/ProjectTypes`)
        .subscribe(this.projectTypes$);
    }
    return this.projectTypes$.asObservable();
  }

  private projectDeliveryMethods$: ReplaySubject<BasicList[]> = new ReplaySubject<BasicList[]>(1);
  private projectDeliveryMethodsRetrieved = false;
  getProjectDeliveryMethods(): Observable<BasicList[]> {
    if (!this.projectDeliveryMethodsRetrieved) {
      this.projectDeliveryMethodsRetrieved = true;
      this.http
        .get<BasicList[]>(`${environment.apiUrl}/api/general/Lookup/ListProjectDeliveryMethods/ProjectDeliveryMethods`)
        .subscribe(this.projectDeliveryMethods$);
    }
    return this.projectDeliveryMethods$.asObservable();
  }

  private classifications$: ReplaySubject<Classification[]> = new ReplaySubject<Classification[]>(1);
  private classificationsRetrieved = false;
  getClassifications(): Observable<Classification[]> {
    if (!this.classificationsRetrieved) {
      this.classificationsRetrieved = true;
      this.http
        .get<Classification[]>(`${environment.apiUrl}/api/general/Lookup/ListCslbClassification/CslbClassification`)
        .subscribe(this.classifications$);
    }
    return this.classifications$.asObservable();
  }

  private certifications$: ReplaySubject<Certification[]> = new ReplaySubject<Certification[]>(1);
  private certificationsRetrieved = false;
  getCertifications(): Observable<Certification[]> {
    if (!this.certificationsRetrieved) {
      this.certificationsRetrieved = true;
      this.http
        .get<
          Certification[]
        >(`${environment.apiUrl}/api/general/Lookup/ListBusinessCertification/BusinessCertification`)
        .subscribe(this.certifications$);
    }
    return this.certifications$.asObservable();
  }

  getUserNavigationRoutes(): Observable<NavigationRoute[]> {
    return this.auth.user$.pipe(
      map(user => {
        let routes: NavigationRoute[];
        if (user == undefined) {
          routes = [
            {
              route: '/about',
              name: 'Why QualityBidders?',
            },
            // {
            //   route: '/opportunities',
            //   name: 'Opportunities',
            // },
            {
              route: '/contacts',
              name: 'Contacts',
            },
            {
              route: '/help',
              name: 'Help',
            },
          ];
        } else if (user.isVendor) {
          routes = [
            {
              route: '/vendor',
              name: 'Home',
              exactMatch: true,
            },
            {
              route: '/vendor/applications',
              name: 'Applications',
            },
            // {
            //   route: '/opportunities',
            //   name: 'Opportunities',
            // },
            {
              route: '/contacts',
              name: 'Contacts',
            },
          ];
        } else if (user.isAgency && !user.isQbat) {
          routes = [
            {
              route: '/agency',
              name: 'Home',
              exactMatch: true,
            },
            {
              route: '/agency/applications',
              name: 'Applications',
            },
            {
              route: '/agency/reports',
              name: 'Reports & Email',
            },
            ...(this.loginService.canAccessFeature('pUserAdmin') ? [{ route: '/agency/users', name: 'User Management' }] : []),
            ...(this.loginService.canAccessFeature('pRoleAdmin') ? [{ route: '/agency/roles', name: 'Role Management' }] : []),
            {
              route: '/agency/admin',
              name: 'Management',
            },
            {
              route: '/agency/user',
              name: 'User Management',
            },
            {
              route: '/agency/role',
              name: 'Role Management',
            },
            {
              route: '/opportunities',
              name: 'Opportunities',
            },
            {
              route: '/help',
              name: 'Help',
            },
          ];
        } else if (user.isQbat) {
          routes = [
            {
              route: '/qbat/prequalification',
              name: 'Prequalification',
            },
            {
              route: '/qbat/cupccaa',
              name: 'CUPCCAA',
            },
            ...(this.loginService.canAccessFeature('pUserAdmin') ? [{ route: '/qbat/users', name: 'User Management' }] : []),
            ...(this.loginService.canAccessFeature('pRoleAdmin') ? [{ route: '/qbat/roles', name: 'Role Management' }] : []),
            {
              route: '/opportunities',
              name: 'Opportunities',
            },
            {
              route: '/help',
              name: 'Help',
            },
          ];
        }
        if (this.loginService.hasPermission('colbi_admin:view')) {
          routes.push({
            route: '/admin',
            name: 'Colbi Admin',
          });
        }

        routes.push({
          route: '/help',
          name: 'Help',
        });
        return routes;
      })
    );
  }
}
